"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6559],{

/***/ 6559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ saveCustomerInfoToSalesboard; },
/* harmony export */   "Br": function() { return /* binding */ acceptPublicSalesboard; },
/* harmony export */   "CS": function() { return /* binding */ setInitialUserInfoToDB; },
/* harmony export */   "CT": function() { return /* binding */ updateSalesboardToDB; },
/* harmony export */   "KY": function() { return /* binding */ postTemplateToDB; },
/* harmony export */   "Lg": function() { return /* binding */ deleteSalesboardFromDB; },
/* harmony export */   "Mu": function() { return /* binding */ getSavedTableItems; },
/* harmony export */   "Nz": function() { return /* binding */ updateCommentsToDB; },
/* harmony export */   "RN": function() { return /* binding */ postEstimateToTemporaryDBAndReturnUid; },
/* harmony export */   "Su": function() { return /* binding */ updateImportedDealConfig; },
/* harmony export */   "Tq": function() { return /* binding */ getSalesboard; },
/* harmony export */   "V4": function() { return /* binding */ deleteSalesboardPassword; },
/* harmony export */   "X$": function() { return /* binding */ updateUserCompanyInfoToDB; },
/* harmony export */   "XP": function() { return /* binding */ updateExistingEstimateToDB; },
/* harmony export */   "ZI": function() { return /* binding */ getPublishedEstimateFromDB; },
/* harmony export */   "bE": function() { return /* binding */ postPublishedEstimateToDB; },
/* harmony export */   "eH": function() { return /* binding */ postEstimateToDB; },
/* harmony export */   "gF": function() { return /* binding */ updateSalesboard; },
/* harmony export */   "jH": function() { return /* binding */ postSalesboardInfo; },
/* harmony export */   "l7": function() { return /* binding */ updateDealConfig; },
/* harmony export */   "lQ": function() { return /* binding */ updatePublishedEstimateToDB; },
/* harmony export */   "mj": function() { return /* binding */ updateSalesboardTaxInfo; },
/* harmony export */   "oU": function() { return /* binding */ updateTeamCommonSettings; },
/* harmony export */   "pc": function() { return /* binding */ updateSalesboardPassword; },
/* harmony export */   "pj": function() { return /* binding */ createNewDocAndReturnRef; },
/* harmony export */   "tP": function() { return /* binding */ updateUserInfoToDB; },
/* harmony export */   "xd": function() { return /* binding */ incrementPublicSalesboardView; }
/* harmony export */ });
/* unused harmony exports saveSalesboardToDB, unacceptPublicSalesboard, updateSalesboardTaxForms, deleteEstimateFromDB, getPublicEstimate, updatePublicEstimate, deletePublicEstimate, getTemplates, updatingExistingTemplateToDB, updateExistingTemplateName, deleteTemplateFromDB, postSavedTableItemToDB, updateExistingSavedTableItemsToDB, deleteSavedTableItemFromDB */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var firebase_firestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5321);
/* harmony import */ var _firebase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1212);
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8006);





// names of firebase collections
var USERS_COLLECTION = "users";
var TEAMS_COLLECTION = "teams";
var ESTIMATES_COLLECTION = "estimates";
var SALESBOARD_COLLECTION = "salesboard";
var PUBLISHED_ESTIMATES_COLLECTION = "publishedEstimates";
var TEMPLATES_COLLECTION = "templates";
var SAVEDTABLEITEMS_COLLECTION = "savedTableItems";
var TEMPORARY_IOS_KAKAO_ESTIMATES_COLLECTION = "iosKakao";
// set initial user information to DB
var setInitialUserInfoToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var name, phoneNumber, user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    name = param.name, phoneNumber = param.phoneNumber;
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    _ctx.prev = 2;
                    if (!user) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 6;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .setDoc */ .pl)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, USERS_COLLECTION, user.uid), {
                        email: user.email,
                        displayName: name,
                        companyPhoneNumber: phoneNumber
                    });
                case 6:
                    (0,firebase_auth__WEBPACK_IMPORTED_MODULE_3__/* .updateProfile */ .ck)(user, {
                        displayName: name
                    }).then(function() {
                    // console.log("profile updated for user cred")
                    });
                    _ctx.next = 10;
                    break;
                case 9:
                    return _ctx.abrupt("return");
                case 10:
                    _ctx.next = 16;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](2);
                    error;
                    toast(error.code, {
                        toastId: "ERROR_UPDATING_USER_INFO"
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                12
            ]
        ]);
    }));
    return function setInitialUserInfoToDB(_) {
        return _ref.apply(this, arguments);
    };
}();
// update existing user settings
var updateUserInfoToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var name, companyName, phoneNumber, user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    name = param.name, companyName = param.companyName, phoneNumber = param.phoneNumber;
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.next = 5;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, USERS_COLLECTION, user.uid), {
                        displayName: name,
                        companyPhoneNumber: phoneNumber
                    });
                case 5:
                    (0,firebase_auth__WEBPACK_IMPORTED_MODULE_3__/* .updateProfile */ .ck)(user, {
                        displayName: name
                    }).then(function() {
                    // console.log("profile updated for user cred")
                    });
                    _ctx.next = 9;
                    break;
                case 8:
                    return _ctx.abrupt("return");
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateUserInfoToDB(_) {
        return _ref.apply(this, arguments);
    };
}();
// update user company settings
var updateUserCompanyInfoToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userInfo) {
        var user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 4;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, USERS_COLLECTION, user.uid), {
                        companyName: userInfo.companyName,
                        companyRegistrationNumber: userInfo.companyRegistrationNumber,
                        companyCeoName: userInfo.companyCeoName,
                        companyAddress: userInfo.companyAddress,
                        companyBizType: userInfo.companyBizClass,
                        companyBizClass: userInfo.companyBizType
                    });
                case 4:
                    _ctx.next = 7;
                    break;
                case 6:
                    return _ctx.abrupt("return");
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateUserCompanyInfoToDB(userInfo) {
        return _ref.apply(this, arguments);
    };
}();
var updateTeamCommonSettings = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var companyName, companyCeoName, companyAddress, companyBizClass, companyBizType, companyBankName, companyBankAccountNumber, companyLogo, companyStamp, teamUid, user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    companyName = param.companyName, companyCeoName = param.companyCeoName, companyAddress = param.companyAddress, companyBizClass = param.companyBizClass, companyBizType = param.companyBizType, companyBankName = param.companyBankName, companyBankAccountNumber = param.companyBankAccountNumber, companyLogo = param.companyLogo, companyStamp = param.companyStamp, teamUid = param.teamUid;
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 5;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, TEAMS_COLLECTION, teamUid), {
                        companyName: companyName,
                        companyCeoName: companyCeoName,
                        companyAddress: companyAddress,
                        companyBizClass: companyBizClass,
                        companyBizType: companyBizType,
                        companyBankName: companyBankName,
                        companyBankAccountNumber: companyBankAccountNumber,
                        companyLogo: companyLogo,
                        companyStamp: companyStamp
                    });
                case 5:
                    _ctx.next = 8;
                    break;
                case 7:
                    return _ctx.abrupt("return");
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateTeamCommonSettings(_) {
        return _ref.apply(this, arguments);
    };
}();
var regularDateToFirebaseDate = function(date) {
    return firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .Timestamp.fromDate */ .EK.fromDate(date);
};
// posts estimate data to temporary IOS Kakao InappBrowser DB
var postEstimateToTemporaryDBAndReturnUid = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, tableTotalCost, estimateName, estimateDate, estimateNumber, estimateExtra, docRef, estimateUid;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    companyName = param.companyName, companyCeoName = param.companyCeoName, companyAddress = param.companyAddress, companyRepresentative = param.companyRepresentative, companyPhoneNumber = param.companyPhoneNumber, companyLogo = param.companyLogo, companyStamp = param.companyStamp, customerCompany = param.customerCompany, customerName = param.customerName, tableInfo = param.tableInfo, tableTotalCost = param.tableTotalCost, estimateName = param.estimateName, estimateDate = param.estimateDate, estimateNumber = param.estimateNumber, estimateExtra = param.estimateExtra;
                    _ctx.next = 3;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .addDoc */ .ET)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, TEMPORARY_IOS_KAKAO_ESTIMATES_COLLECTION), {
                        companyName: companyName,
                        companyCeoName: companyCeoName,
                        companyAddress: companyAddress,
                        companyRepresentative: companyRepresentative,
                        companyPhoneNumber: companyPhoneNumber,
                        companyLogo: companyLogo,
                        companyStamp: companyStamp,
                        customerCompany: customerCompany,
                        customerName: customerName,
                        tableInfo: tableInfo,
                        tableTotalCost: tableTotalCost,
                        estimateName: estimateName,
                        estimateDate: estimateDate,
                        estimateNumber: estimateNumber,
                        estimateExtra: estimateExtra
                    });
                case 3:
                    docRef = _ctx.sent;
                    estimateUid = docRef.id;
                    return _ctx.abrupt("return", estimateUid);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postEstimateToTemporaryDBAndReturnUid(_) {
        return _ref.apply(this, arguments);
    };
}();
// posts estimate data to DB
var postEstimateToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, tableTotalCost, estimateName, estimateDate, estimateNumber, estimateExtra, user, createdTime;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    companyName = param.companyName, companyCeoName = param.companyCeoName, companyAddress = param.companyAddress, companyRepresentative = param.companyRepresentative, companyPhoneNumber = param.companyPhoneNumber, companyLogo = param.companyLogo, companyStamp = param.companyStamp, customerCompany = param.customerCompany, customerName = param.customerName, tableInfo = param.tableInfo, tableTotalCost = param.tableTotalCost, estimateName = param.estimateName, estimateDate = param.estimateDate, estimateNumber = param.estimateNumber, estimateExtra = param.estimateExtra;
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    createdTime = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .serverTimestamp */ .Bt)();
                    if (!user) {
                        _ctx.next = 13;
                        break;
                    }
                    if (!(estimateName === "")) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 7;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .addDoc */ .ET)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, ESTIMATES_COLLECTION), {
                        uid: user.uid,
                        companyName: companyName,
                        companyCeoName: companyCeoName,
                        companyAddress: companyAddress,
                        companyRepresentative: companyRepresentative,
                        companyPhoneNumber: companyPhoneNumber,
                        companyLogo: companyLogo,
                        companyStamp: companyStamp,
                        customerCompany: customerCompany,
                        customerName: customerName,
                        tableInfo: tableInfo,
                        tableTotalCost: tableTotalCost,
                        estimateName: "견적서 이름이 없습니다",
                        estimateDate: estimateDate,
                        estimateNumber: estimateNumber,
                        estimateExtra: estimateExtra,
                        createdTime: createdTime
                    });
                case 7:
                    _ctx.next = 11;
                    break;
                case 9:
                    _ctx.next = 11;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .addDoc */ .ET)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, ESTIMATES_COLLECTION), {
                        uid: user.uid,
                        companyName: companyName,
                        companyCeoName: companyCeoName,
                        companyAddress: companyAddress,
                        companyRepresentative: companyRepresentative,
                        companyPhoneNumber: companyPhoneNumber,
                        companyLogo: companyLogo,
                        companyStamp: companyStamp,
                        customerCompany: customerCompany,
                        customerName: customerName,
                        tableInfo: tableInfo,
                        tableTotalCost: tableTotalCost,
                        estimateName: estimateName,
                        estimateDate: estimateDate,
                        estimateNumber: estimateNumber,
                        estimateExtra: estimateExtra,
                        createdTime: createdTime
                    });
                case 11:
                    _ctx.next = 14;
                    break;
                case 13:
                    return _ctx.abrupt("return");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postEstimateToDB(_) {
        return _ref.apply(this, arguments);
    };
}();
// posts salesboard info data to DB (setting)
var postSalesboardInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var salesboardUid, salesboardName, supplier, customerUid, customer, supplierCompanyLogo, supplierCompanyStamp, createdTime, user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    salesboardUid = param.salesboardUid, salesboardName = param.salesboardName, supplier = param.supplier, customerUid = param.customerUid, customer = param.customer, supplierCompanyLogo = param.supplierCompanyLogo, supplierCompanyStamp = param.supplierCompanyStamp;
                    createdTime = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .serverTimestamp */ .Bt)();
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 6;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .setDoc */ .pl)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        ownerUid: user.uid,
                        ownerEmail: user.email,
                        createdTime: createdTime,
                        lastEdited: createdTime,
                        salesboardName: salesboardName,
                        supplier: supplier,
                        customerUid: customerUid,
                        customer: customer,
                        supplierCompanyLogo: supplierCompanyLogo,
                        supplierCompanyStamp: supplierCompanyStamp
                    });
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postSalesboardInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
// updates existing salesboard data (setting)
var updateSalesboard = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var salesboardUid, salesboardName, supplier, customerUid, customer, supplierCompanyLogo, supplierCompanyStamp, user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    salesboardUid = param.salesboardUid, salesboardName = param.salesboardName, supplier = param.supplier, customerUid = param.customerUid, customer = param.customer, supplierCompanyLogo = param.supplierCompanyLogo, supplierCompanyStamp = param.supplierCompanyStamp;
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 5;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        // lastEdited: createdTime,
                        salesboardName: salesboardName,
                        supplier: supplier,
                        customerUid: customerUid,
                        customer: customer,
                        supplierCompanyLogo: supplierCompanyLogo,
                        supplierCompanyStamp: supplierCompanyStamp
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateSalesboard(_) {
        return _ref.apply(this, arguments);
    };
}();
// posts salesboard data to DB (editor)
var saveSalesboardToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, estimates, lastEdited) {
        var createdTime, user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    createdTime = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .serverTimestamp */ .Bt)();
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 5;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .setDoc */ .pl)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        ownerUid: user.uid,
                        ownerEmail: user.email,
                        lastEdited: lastEdited,
                        createdTime: createdTime,
                        estimates: estimates
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveSalesboardToDB(salesboardUid, estimates, lastEdited) {
        return _ref.apply(this, arguments);
    };
}();
// updates existing salesboard data to DB
var updateSalesboardToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, estimateObjectToAdd) {
        var createdTime, user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    createdTime = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .serverTimestamp */ .Bt)();
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 5;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        lastEdited: createdTime,
                        estimates: (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .arrayUnion */ .vr)(estimateObjectToAdd)
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateSalesboardToDB(salesboardUid, estimateObjectToAdd) {
        return _ref.apply(this, arguments);
    };
}();
// updates dealConfig salesboard data to DB
var updateDealConfig = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, estimateObjectToAdd) {
        var createdTime, user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    createdTime = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .serverTimestamp */ .Bt)();
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 5;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        lastEdited: createdTime,
                        dealConfig: estimateObjectToAdd,
                        dealConfigPaymentImported: false
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateDealConfig(salesboardUid, estimateObjectToAdd) {
        return _ref.apply(this, arguments);
    };
}();
// updates dealConfig paymentInfo salesboard data to DB
var updateImportedDealConfig = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid) {
        var user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 4;
                        break;
                    }
                    _ctx.next = 4;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        dealConfigPaymentImported: true
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateImportedDealConfig(salesboardUid) {
        return _ref.apply(this, arguments);
    };
}();
// updates salesboard with customer company info (공급받는자 사업자등록 정보)
var saveCustomerInfoToSalesboard = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, taxFormReceivingEmail) {
        var user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 4;
                        break;
                    }
                    _ctx.next = 4;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        taxFormReceivingEmail: taxFormReceivingEmail
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveCustomerInfoToSalesboard(salesboardUid, taxFormReceivingEmail) {
        return _ref.apply(this, arguments);
    };
}();
// get salesboard if exists
var getSalesboard = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid) {
        var salesboardRef, estimateSnap;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    salesboardRef = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid);
                    _ctx.next = 3;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getDoc */ .QT)(salesboardRef);
                case 3:
                    estimateSnap = _ctx.sent;
                    if (estimateSnap.data()) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", false);
                case 6:
                    return _ctx.abrupt("return", estimateSnap);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSalesboard(salesboardUid) {
        return _ref.apply(this, arguments);
    };
}();
// make salesboard 확정
var acceptPublicSalesboard = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, estimateObjectToAdd) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        estimates: (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .arrayUnion */ .vr)(estimateObjectToAdd)
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function acceptPublicSalesboard(salesboardUid, estimateObjectToAdd) {
        return _ref.apply(this, arguments);
    };
}();
var unacceptPublicSalesboard = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, estimateObjectToAdd) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        estimates: (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .arrayUnion */ .vr)(estimateObjectToAdd)
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function unacceptPublicSalesboard(salesboardUid, estimateObjectToAdd) {
        return _ref.apply(this, arguments);
    };
}();
var incrementPublicSalesboardView = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        numAccessed: (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .increment */ .nP)(1)
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function incrementPublicSalesboardView(salesboardUid) {
        return _ref.apply(this, arguments);
    };
}();
// updating customer tax info
var updateSalesboardTaxInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, taxInfo) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        taxInfo: taxInfo
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateSalesboardTaxInfo(salesboardUid, taxInfo) {
        return _ref.apply(this, arguments);
    };
}();
// updating tax form info
var updateSalesboardTaxForms = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, taxForm) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        taxForms: taxForm
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateSalesboardTaxForms(salesboardUid, taxForm) {
        return _ref.apply(this, arguments);
    };
}();
// update salesboard password
var updateSalesboardPassword = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, password) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        password: password
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateSalesboardPassword(salesboardUid, password) {
        return _ref.apply(this, arguments);
    };
}();
// delete salesboard password
var deleteSalesboardPassword = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        password: ""
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteSalesboardPassword(salesboardUid) {
        return _ref.apply(this, arguments);
    };
}();
// deletes salesboard from DB
var deleteSalesboardFromDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .deleteDoc */ .oe)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteSalesboardFromDB(salesboardUid) {
        return _ref.apply(this, arguments);
    };
}();
// create new doc
var createNewDocAndReturnRef = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var user, collectionRef, docRef;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 5;
                        break;
                    }
                    collectionRef = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION);
                    docRef = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(collectionRef);
                    return _ctx.abrupt("return", docRef);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createNewDocAndReturnRef() {
        return _ref.apply(this, arguments);
    };
}();
// updates existing estimate with new estimate data to DB
var updateExistingEstimateToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, tableTotalCost, estimateName, estimateDate, estimateNumber, estimateExtra, estimateId) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, ESTIMATES_COLLECTION, estimateId), {
                        companyName: companyName,
                        companyCeoName: companyCeoName,
                        companyAddress: companyAddress,
                        companyRepresentative: companyRepresentative,
                        companyPhoneNumber: companyPhoneNumber,
                        companyLogo: companyLogo,
                        companyStamp: companyStamp,
                        customerCompany: customerCompany,
                        customerName: customerName,
                        tableInfo: tableInfo,
                        tableTotalCost: tableTotalCost,
                        estimateName: estimateName,
                        estimateDate: estimateDate,
                        estimateNumber: estimateNumber,
                        estimateExtra: estimateExtra
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateExistingEstimateToDB(companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, tableTotalCost, estimateName, estimateDate, estimateNumber, estimateExtra, estimateId) {
        return _ref.apply(this, arguments);
    };
}();
// deletes estimate from DB
var deleteEstimateFromDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(estimateId) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .deleteDoc */ .oe)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, ESTIMATES_COLLECTION, estimateId));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteEstimateFromDB(estimateId) {
        return _ref.apply(this, arguments);
    };
}();
// 출시 - posts a public published estimate to DB
var postPublishedEstimateToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, tableTotalCost, estimateName, estimateDate, estimateNumber, estimateExtra, estimateUid, isPublic) {
        var user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 4;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .addDoc */ .ET)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, PUBLISHED_ESTIMATES_COLLECTION), {
                        ownerUid: user.uid,
                        ownerEmail: user.email,
                        companyName: companyName,
                        companyCeoName: companyCeoName,
                        companyAddress: companyAddress,
                        companyRepresentative: companyRepresentative,
                        companyPhoneNumber: companyPhoneNumber,
                        companyLogo: companyLogo,
                        companyStamp: companyStamp,
                        customerCompany: customerCompany,
                        customerName: customerName,
                        tableInfo: tableInfo,
                        tableTotalCost: tableTotalCost,
                        estimateName: estimateName,
                        estimateDate: estimateDate,
                        estimateNumber: estimateNumber,
                        estimateExtra: estimateExtra,
                        estimateUid: estimateUid,
                        isPublic: isPublic
                    });
                case 4:
                    _ctx.next = 7;
                    break;
                case 6:
                    return _ctx.abrupt("return");
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postPublishedEstimateToDB(companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, tableTotalCost, estimateName, estimateDate, estimateNumber, estimateExtra, estimateUid, isPublic) {
        return _ref.apply(this, arguments);
    };
}();
// updates existing public published estimate with new estimate data
var updatePublishedEstimateToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, tableTotalCost, estimateName, estimateDate, estimateNumber, estimateExtra, estimateUid, isPublic, publishedEstimateUid) {
        var user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 4;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .setDoc */ .pl)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, PUBLISHED_ESTIMATES_COLLECTION, publishedEstimateUid), {
                        ownerUid: user.uid,
                        ownerEmail: user.email,
                        companyName: companyName,
                        companyCeoName: companyCeoName,
                        companyAddress: companyAddress,
                        companyRepresentative: companyRepresentative,
                        companyPhoneNumber: companyPhoneNumber,
                        companyLogo: companyLogo,
                        companyStamp: companyStamp,
                        customerCompany: customerCompany,
                        customerName: customerName,
                        tableInfo: tableInfo,
                        tableTotalCost: tableTotalCost,
                        estimateName: estimateName,
                        estimateDate: estimateDate,
                        estimateNumber: estimateNumber,
                        estimateExtra: estimateExtra,
                        estimateUid: estimateUid,
                        isPublic: isPublic
                    });
                case 4:
                    _ctx.next = 7;
                    break;
                case 6:
                    return _ctx.abrupt("return");
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updatePublishedEstimateToDB(companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, tableTotalCost, estimateName, estimateDate, estimateNumber, estimateExtra, estimateUid, isPublic, publishedEstimateUid) {
        return _ref.apply(this, arguments);
    };
}();
// get published estimate from DB if exists
// @estimateUid - uid of the original estimate
var getPublishedEstimateFromDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(estimateUid, setPublishedEstimate, setShowPublicURL) {
        var publishedCollection, q;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    publishedCollection = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, PUBLISHED_ESTIMATES_COLLECTION);
                    q = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .query */ .IO)(publishedCollection, (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .where */ .ar)("estimateUid", "==", estimateUid));
                    (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .onSnapshot */ .cf)(q, function(snapshot) {
                        var resultDoc = snapshot.docs.map(function(doc) {
                            return {
                                id: doc.id,
                                data: {
                                    ownerUid: doc.data().ownerUid,
                                    ownerEmail: doc.data().ownerEmail,
                                    companyName: doc.data().companyName,
                                    companyCeoName: doc.data().companyCeoName,
                                    companyAddress: doc.data().companyAddress,
                                    companyRepresentative: doc.data().companyRepresentative,
                                    companyPhoneNumber: doc.data().companyPhoneNumber,
                                    companyLogo: doc.data().companyLogo,
                                    companyStamp: doc.data().companyStamp,
                                    customerCompany: doc.data().customerCompany,
                                    customerName: doc.data().customerName,
                                    tableInfo: doc.data().tableInfo,
                                    tableTotalCost: doc.data().tableTotalCost,
                                    estimateName: doc.data().estimateName,
                                    estimateDate: doc.data().estimateDate,
                                    estimateNumber: doc.data().estimateNumber,
                                    estimateExtra: doc.data().estimateExtra,
                                    estimateUid: doc.data().estimateUid,
                                    isPublic: doc.data().isPublic
                                }
                            };
                        });
                        if (resultDoc[0]) {
                            setPublishedEstimate(resultDoc[0]);
                            setShowPublicURL(resultDoc[0].data.isPublic);
                        }
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPublishedEstimateFromDB(estimateUid, setPublishedEstimate, setShowPublicURL) {
        return _ref.apply(this, arguments);
    };
}();
// get published public estimate if exists
var getPublicEstimate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(estimateUid) {
        var publishedDoc, estimateSnap;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    publishedDoc = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, PUBLISHED_ESTIMATES_COLLECTION, estimateUid);
                    _ctx.next = 3;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getDoc */ .QT)(publishedDoc);
                case 3:
                    estimateSnap = _ctx.sent;
                    if (!(!estimateSnap.data() || !estimateSnap.data().isPublic)) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", false);
                case 6:
                    return _ctx.abrupt("return", estimateSnap);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPublicEstimate(estimateUid) {
        return _ref.apply(this, arguments);
    };
}();
// updates public esimtate
var updatePublicEstimate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(estimateUid, isAccepted) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, PUBLISHED_ESTIMATES_COLLECTION, estimateUid), {
                        isAccepted: isAccepted
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updatePublicEstimate(estimateUid, isAccepted) {
        return _ref.apply(this, arguments);
    };
}();
// unpublishes (deletes) public published estimate (currently unused)
var deletePublicEstimate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(estimateUid) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .deleteDoc */ .oe)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, PUBLISHED_ESTIMATES_COLLECTION, estimateUid));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deletePublicEstimate(estimateUid) {
        return _ref.apply(this, arguments);
    };
}();
var updateCommentsToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(salesboardUid, comments) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SALESBOARD_COLLECTION, salesboardUid), {
                        comments: comments
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateCommentsToDB(salesboardUid, comments) {
        return _ref.apply(this, arguments);
    };
}();
// get templates
var getTemplates = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ownerUids) {
        var q, querySnapshot, allTemplates;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    q = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, TEMPLATES_COLLECTION), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .where */ .ar)("ownerUid", "in", ownerUids), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .orderBy */ .Xo)("createdTime", "desc"));
                    _ctx.next = 3;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getDocs */ .PL)(q);
                case 3:
                    querySnapshot = _ctx.sent;
                    allTemplates = [];
                    querySnapshot.forEach(function(doc) {
                        allTemplates.push(doc);
                    });
                    return _ctx.abrupt("return", allTemplates);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTemplates(ownerUids) {
        return _ref.apply(this, arguments);
    };
}();
// post template
var postTemplateToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateName, param) {
        var companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, estimateName, estimateDate, estimateNumber, estimateExtra, user, createdTime;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    companyName = param.companyName, companyCeoName = param.companyCeoName, companyAddress = param.companyAddress, companyRepresentative = param.companyRepresentative, companyPhoneNumber = param.companyPhoneNumber, companyLogo = param.companyLogo, companyStamp = param.companyStamp, customerCompany = param.customerCompany, customerName = param.customerName, tableInfo = param.tableInfo, estimateName = param.estimateName, estimateDate = param.estimateDate, estimateNumber = param.estimateNumber, estimateExtra = param.estimateExtra;
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    createdTime = regularDateToFirebaseDate(new Date());
                    if (!user) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.next = 6;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .addDoc */ .ET)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, TEMPLATES_COLLECTION), {
                        uid: user.uid,
                        templateName: templateName,
                        companyName: companyName,
                        companyCeoName: companyCeoName,
                        companyAddress: companyAddress,
                        companyRepresentative: companyRepresentative,
                        companyPhoneNumber: companyPhoneNumber,
                        companyLogo: companyLogo,
                        companyStamp: companyStamp,
                        customerCompany: customerCompany,
                        customerName: customerName,
                        tableInfo: tableInfo,
                        estimateName: estimateName,
                        estimateDate: estimateDate,
                        estimateNumber: estimateNumber,
                        estimateExtra: estimateExtra,
                        createdTime: createdTime
                    });
                case 6:
                    _ctx.next = 9;
                    break;
                case 8:
                    return _ctx.abrupt("return");
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postTemplateToDB(templateName, _) {
        return _ref.apply(this, arguments);
    };
}();
// updates existing template with new template data to DB
var updatingExistingTemplateToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateName, templateId, param) {
        var companyName, companyCeoName, companyAddress, companyRepresentative, companyPhoneNumber, companyLogo, companyStamp, customerCompany, customerName, tableInfo, tableTotalCost, estimateName, estimateDate, estimateNumber, estimateExtra;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    companyName = param.companyName, companyCeoName = param.companyCeoName, companyAddress = param.companyAddress, companyRepresentative = param.companyRepresentative, companyPhoneNumber = param.companyPhoneNumber, companyLogo = param.companyLogo, companyStamp = param.companyStamp, customerCompany = param.customerCompany, customerName = param.customerName, tableInfo = param.tableInfo, tableTotalCost = param.tableTotalCost, estimateName = param.estimateName, estimateDate = param.estimateDate, estimateNumber = param.estimateNumber, estimateExtra = param.estimateExtra;
                    _ctx.next = 3;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, TEMPLATES_COLLECTION, templateId), {
                        templateName: templateName,
                        companyName: companyName,
                        companyCeoName: companyCeoName,
                        companyAddress: companyAddress,
                        companyRepresentative: companyRepresentative,
                        companyPhoneNumber: companyPhoneNumber,
                        companyLogo: companyLogo,
                        companyStamp: companyStamp,
                        customerCompany: customerCompany,
                        customerName: customerName,
                        tableInfo: tableInfo,
                        tableTotalCost: tableTotalCost,
                        estimateName: estimateName,
                        estimateDate: estimateDate,
                        estimateNumber: estimateNumber,
                        estimateExtra: estimateExtra
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updatingExistingTemplateToDB(templateName, templateId, _) {
        return _ref.apply(this, arguments);
    };
}();
// update only the name of template
var updateExistingTemplateName = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateName, templateId) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, TEMPLATES_COLLECTION, templateId), {
                        templateName: templateName
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateExistingTemplateName(templateName, templateId) {
        return _ref.apply(this, arguments);
    };
}();
// deletes template from DB
var deleteTemplateFromDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateId) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .deleteDoc */ .oe)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, TEMPLATES_COLLECTION, templateId));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteTemplateFromDB(templateId) {
        return _ref.apply(this, arguments);
    };
}();
// get saved table items from DB
var getSavedTableItems = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ownerUids) {
        var q, querySnapshot, tableItems;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    q = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SAVEDTABLEITEMS_COLLECTION), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .where */ .ar)("uid", "in", ownerUids));
                    _ctx.next = 3;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getDocs */ .PL)(q);
                case 3:
                    querySnapshot = _ctx.sent;
                    tableItems = [];
                    querySnapshot.forEach(function(doc) {
                        tableItems.push(doc);
                    });
                    return _ctx.abrupt("return", tableItems[0]);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSavedTableItems(ownerUids) {
        return _ref.apply(this, arguments);
    };
}();
// post saved table item to DB
var postSavedTableItemToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tableInfo) {
        var user;
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    user = _firebase__WEBPACK_IMPORTED_MODULE_2__/* .auth.currentUser */ .I8.currentUser;
                    if (!user) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 4;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .addDoc */ .ET)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SAVEDTABLEITEMS_COLLECTION), {
                        uid: user.uid,
                        tableInfo: tableInfo
                    });
                case 4:
                    _ctx.next = 7;
                    break;
                case 6:
                    return _ctx.abrupt("return");
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postSavedTableItemToDB(tableInfo) {
        return _ref.apply(this, arguments);
    };
}();
// updates existing saved table items with new template data to DB
var updateExistingSavedTableItemsToDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tableInfo, tableInfoId) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .updateDoc */ .r7)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SAVEDTABLEITEMS_COLLECTION, tableInfoId), {
                        tableInfo: tableInfo
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateExistingSavedTableItemsToDB(tableInfo, tableInfoId) {
        return _ref.apply(this, arguments);
    };
}();
// deletes saved table item from DB
var deleteSavedTableItemFromDB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tableInfoId) {
        return _vercel_path0_ocena_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .deleteDoc */ .oe)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .doc */ .JU)(_firebase__WEBPACK_IMPORTED_MODULE_2__.db, SAVEDTABLEITEMS_COLLECTION, tableInfoId));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteSavedTableItemFromDB(tableInfoId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);